import get from 'lodash.get';
import { emptyArray } from 'ui-components/default-props/empty';

export const selectIds = (state) => get(state, 'selectedCustomerIds', emptyArray);
export const selectCount = (state) => get(selectIds(state), 'length');
